import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link from "@insite/mobius/Link";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import parse from "html-react-parser";
import truncate from "lodash/truncate";
import * as React from "react";
import { useState } from "react";
import { css } from "styled-components";

interface Props extends WidgetProps, HasCategoryContext {}

export interface CategoryDetailBannerStyles {
    container?: InjectableCss;
    linkStyles?: InjectableCss;
}

export const bannerStyles: CategoryDetailBannerStyles = {
    container: {
        css: css`
            border: 2px solid red;
            background-color: ${COLORS.white};
            font-size: ${TYPOGRAPHY.size.smaller};
            line-height: 28px;
            padding: 50px 100px;
            color: ${COLORS.text.mineShaft};
            border: 4px solid #f2f2f2;

            margin-bottom: 64px;
            p {
                margin-bottom: 8px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 50px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    linkStyles: {
        css: css`
            margin-top: 0px;
            margin-bottom: 10px;
            &:focus {
                outline-color: transparent !important;
            }
            > span {
                color: #262525 !important ;
                font-size: ${TYPOGRAPHY.size.large};
                font-weight: ${TYPOGRAPHY.weight.mediumbold};
                line-height: ${TYPOGRAPHY.lineHeight.base};
            }
        `,
    },
};

const styles = bannerStyles;

const CategoryDetailBanner = ({ category }: Props) => {
    if (!category || !category.htmlContent) {
        return null;
    }

    const renderingDescription = category.htmlContent.split("</head>");
    const contentLength =
        renderingDescription?.length > 1 ? renderingDescription[1].length : category.htmlContent?.length;

    const [status, setStatus] = useState(false);
    const toggleStatus = () => {
        setStatus(!status);
    };

    return (
        <StyledWrapper {...styles.container} data-test-selector="categoryDetailBanner_htmlContent">
            {status
                ? parse(transformContentHtml(category.htmlContent), parserOptions)
                : parse(transformContentHtml(truncate(category.htmlContent, { length: 350 })), parserOptions)}
            {contentLength > 350 && (
                <Link href="" onClick={toggleStatus} {...styles.linkStyles}>
                    {status ? "Show Less" : "Show More"}
                </Link>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withCategory(CategoryDetailBanner),
    definition: {
        group: "Category Details",
        icon: "image-landscape",
        allowedContexts: ["CategoryDetailsPage", "ProductListPage"],
    },
};

export default widgetModule;
